/**
 * B616 leg 3b — the "Become an Insider" band above the site foot (built from
 * the board line; B614's poster wall draws it at its foot — redline pending).
 * A composition of package primitives: one email field and JOIN. The refusal
 * arrives on the press, at the field; joined, the field gives way to the
 * thanks, said as a status so a screen reader hears it.
 */
import type { ReactElement } from "react";
import { Button, Input } from "@transact/ui";
import { INSIDER_JOINED, INSIDER_PITCH, INSIDER_TITLE } from "../lib/insider.js";

export function InsiderBand(props: {
  readonly email: string;
  readonly onEmail: (value: string) => void;
  readonly onJoin: () => void;
  readonly phase: "idle" | "busy" | "joined";
  readonly error?: string | undefined;
}): ReactElement {
  return (
    <section className="insider" aria-labelledby="insider-title" aria-busy={props.phase === "busy" || undefined}>
      <div className="insider-words">
        <h2 id="insider-title" className="insider-title">
          {INSIDER_TITLE}
        </h2>
        <p className="insider-pitch">{INSIDER_PITCH}</p>
      </div>
      {props.phase === "joined" ? (
        <p className="insider-joined" role="status">
          {INSIDER_JOINED}
        </p>
      ) : (
        <div className="insider-form">
          <Input
            id="insider-email"
            label="Your email"
            type="email"
            value={props.email}
            placeholder="you@example.com"
            onChange={props.onEmail}
            error={props.error}
          />
          <Button onClick={props.onJoin} busy={props.phase === "busy"}>
            Join
          </Button>
        </div>
      )}
    </section>
  );
}
